import { ReactElement } from 'react'

import { BalanceSideProvider } from '@features/balanceLedger'
import { BalanceSide } from '@features/balanceLedger/enums/balanceSide'
// TODO(AUDIT-255): cross-view import until balance ledger UI is extracted into the feature.
import { SuppliersBalanceFiltersProvider } from '@views/suppliersBalance/contexts/suppliersBalanceFiltersContext'
import { SuppliersBalanceOverviewContent } from '@views/suppliersBalance/SuppliersBalanceOverview'

export const CustomersBalanceOverview = (): ReactElement => (
  <BalanceSideProvider side={BalanceSide.Customer}>
    <SuppliersBalanceFiltersProvider>
      <SuppliersBalanceOverviewContent />
    </SuppliersBalanceFiltersProvider>
  </BalanceSideProvider>
)
